import { ComponentConfiguration } from './component_configuration';

export class CardsGeneratorConfiguration extends ComponentConfiguration {
  constructor(json: Record<string, any>) {
    super(json);
  }
}
